<script setup lang="ts">
import PromoPackageIcon from '@assets/icons/promo-package.svg?component';
import { ref } from 'vue';

const props = defineProps<{
  text: string;
  code: string;
}>();

const showTooltip = ref(false);

const copyPromoCode = async () => {
  try {
    if (!props?.code) return;
    await navigator.clipboard.writeText(props?.code);
    showTooltip.value = true;

    setTimeout(() => {
      showTooltip.value = false;
    }, 2000);
  } catch (error) {
    showTooltip.value = false;
  }
};
</script>

<template>
  <div
    class="promo-block relative z-40 bg-copper-500 font-inter"
    :class="{ 'cursor-pointer': code, 'cursor-default': !code }"
    @click="copyPromoCode"
  >
    <div class="flex items-center justify-center gap-8 py-8 text-center text-12 font-[450] text-white md:text-14">
      <PromoPackageIcon class="size-20 shrink-0" />
      <span
        class="promo-block__text"
        v-html="text"
      /><template v-if="code">
        <span class="whitespace-nowrap"> <strong>{{ code }}</strong></span>
      </template>
    </div>
    <div
      v-if="showTooltip"
      class="tooltip absolute left-1/2 top-full mt-2 -translate-x-1/2 rounded bg-black px-8 pb-4 pt-6 text-12 text-white shadow-md md:text-14 lg:text-16"
    >
      Promo code copied!
    </div>
  </div>
</template>

<style scoped>
.promo-block__text :deep(p) {
  margin: 0;
  display: inline;
}

.promo-block__text :deep(p + p)::before {
  content: ' ';
}

.tooltip {
  animation: fadeInOut 0.5s ease-in-out;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
